import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import NotificationsPopupMenuView from 'views/notification/NotificationsPopupMenuView';
import UserPopupMenuView from 'views/main/MainContainer/UserPopupMenuView';
import MainSidebarView from 'views/main/MainContainer/MainSidebarView';
import DevicesPopupMenuView from 'views/main/MainContainer/DevicesPopupMenuView';
import ToolTipView from 'views/utils/ToolTipView';
import AnalyticsUtil from 'utils/AnalyticsUtil';
import NavigationUtil from 'utils/NavigationUtil';
import ViewerSocialProfile from 'models/user/ViewerSocialProfile';
import templateHtml from 'templates/main/MainContainer/TopHeaderBarView.html';
import MaxConnectionsDialog from 'components/ConnectionDialog/MaxConnectionsDialog';
import ConnectionsDispatcher from 'events/ConnectionsDispatcher';
import GroupDispatcher from 'events/GroupDispatcher';
import ReactComponentView from 'views/main/react/ReactComponentView';
import MutualConnectionsModalWrapper from 'components/MutualConnections/MutualConnectionsModalWrapper';
import GroupErrorDialogBackboneWrapper from 'InboxPage/GroupErrorDialogBackboneWrapper';
import WidgetLimitErrorDialog from 'Conversations/WidgetLimitErrorDialog';
import AvatarRefreshInstance from './AvatarRefreshInstance';
import { isReadonlyMode, isProductSupportMode } from 'system/SystemUtil';
import 'styles/badges.common.module.css';
import 'styles/top-header-bar.module.css';

var tooltipMapper = [
    {
        selector: '.connect-iq',
        label: 'garmin.app.store',
        placement: 'bottom'
    },
    {
        selector: '.upload-import',
        label: 'upload_or_import_activity',
        placement: 'bottom'
    },
    {
        selector: '.notifications',
        label: 'requests_and_notifications',
        placement: 'bottom'
    },
    {
        selector: '.device-sync',
        label: 'device_and_sync_status',
        placement: 'bottomLeft'
    },
    {
        selector: '.user-profile',
        label: 'profile_and_account',
        placement: 'bottomLeft'
    }
];

var TopHeaderBarView = Backbone.View.extend({
    events: {
        'click .main-nav-toggle': 'toggleSidebar',
        'click .js-import-data': 'handleNavigationLink',
        'click .js-how-to-sync': 'handleNavigationLink',
        'click .logo': 'handleNavigationLink',
        'click .notifications .header-nav-link': 'onNotificationTriggerClicked',
        'click .device-sync .header-nav-link': 'onDeviceSyncTriggerClicked',
        'click .header-nav-link': 'handleDropdownClick',
        'click .header-nav-menu': 'handleDropdownContentClick'
    },

    template: _.template(templateHtml),

    initialize: function(args) {
        this.notificationPollRate =
            window.queueNotificationTimeout && !isNaN(window.queueNotificationTimeout)
                ? window.queueNotificationTimeout
                : args.pollRate;
        this.deviceNotificationPollRate =
            window.queuePollRate && !isNaN(window.queuePollRate) ? window.queuePollRate : args.pollRate;
        this.userProfile = args.userProfile;
        this.userPreferences = args.userPreferences;
        this.messageAndDevicesNotificationsEnabled = args.messageAndDevicesNotificationsEnabled;
        this.groupInviteSpammingDays = args.groupInviteSpammingDays;
        this.isProductSupportMode = isProductSupportMode();
        this.trainingPlans = args.trainingPlans;

        ConnectionsDispatcher.on(
            ConnectionsDispatcher.Events.ON_MAX_CONNECTIONS_MODAL_SHOWED,
            this.showMaxConnectionsModal,
            this
        );
        ConnectionsDispatcher.on(
            ConnectionsDispatcher.Events.ON_MUTUAL_CONNECTIONS_MODAL_SHOWED,
            this.showMutualConnectionsModal,
            this
        );
        GroupDispatcher.on(GroupDispatcher.Events.ON_GROUP_REQUEST_ERROR, this.showGroupErrorModal, this);

        this.gcPlusFrameRole = args.gcPlusFrameRole; // Clean up ticket: CA-165763

        this.triggerAvatarRefresh = false;
    },

    showMaxConnectionsModal: function({ isUserConnectionsOverLimitation, nameToDisplay }) {
        if (typeof nameToDisplay === 'string' && typeof isUserConnectionsOverLimitation === 'boolean') {
            // Append a class to header to change the z-index in order to put the modal on the top of the page
            document.getElementsByClassName('header')[0].classList.add('show-modal');
            this.maxConnectionsDialog = new ReactComponentView();
            this.maxConnectionsDialog.renderComponent(
                MaxConnectionsDialog,
                this.$('.max-connections-modal-placeholder')[0],
                {
                    isUserConnectionsOverLimitation: isUserConnectionsOverLimitation,
                    nameToDisplay: nameToDisplay,
                    shouldModalOpen: true,
                    onCloseModal: function() {
                        this.maxConnectionsDialog.removeComponent();
                        // Revert the modified class list when closing the modal
                        document.getElementsByClassName('header')[0].classList.remove('show-modal');
                    }.bind(this)
                }
            );
        }
    },

    showMutualConnectionsModal: function({ displayName, mutualConnectionsCount }) {
        if (
            typeof displayName !== 'undefined' &&
            displayName !== null &&
            typeof mutualConnectionsCount !== 'undefined' &&
            mutualConnectionsCount !== null
        ) {
            // Append a class to header to change the z-index in order to put the modal on the top of the page
            document.getElementsByClassName('header')[0].classList.add('show-modal');
            this.mutualConnectionsModalWrapper = new ReactComponentView();
            this.mutualConnectionsModalWrapper.renderComponent(
                MutualConnectionsModalWrapper,
                this.$('.mutual-connections-modal-placeholder')[0],
                {
                    displayName: displayName,
                    shouldModalOpen: true,
                    onCloseModal: function() {
                        this.mutualConnectionsModalWrapper.removeComponent();
                        // Revert the modified class list when closing the modal
                        document.getElementsByClassName('header')[0].classList.remove('show-modal');
                    }.bind(this),
                    mutualConnectionsCount: mutualConnectionsCount
                }
            );
        }
    },

    showGroupErrorModal: function(errorType) {
        // Append a class to header to change the z-index in order to put the modal on the top of the page
        document.getElementsByClassName('header')[0].classList.add('show-modal');
        this.groupErrorDialog = new ReactComponentView();
        this.groupErrorDialog.renderComponent(
            GroupErrorDialogBackboneWrapper,
            this.$('.group-request-error-modal-placeholder')[0],
            {
                open: true,
                onClose: function() {
                    this.groupErrorDialog.removeComponent();
                    // Revert the modified class list when closing the modal
                    document.getElementsByClassName('header')[0].classList.remove('show-modal');
                }.bind(this),
                errorType
            }
        );
    },
    /**
     * Render the top header bar menu.
     */
    render: function() {
        var html = this.template({
            Localizer: Localizer,
            url: NavigationUtil.url,
            actorAvatarUrl: this.getActorAvatarUrl(),
            isProductSupportMode: this.isProductSupportMode
        });

        this.$el.html(html);

        this.renderProfileImage();

        ViewerSocialProfile.on(
            'change',
            function() {
                this.renderProfileImage();
                this.userPopupMenuView.render();
            },
            this
        );

        this.notificationsPopupMenuView = new NotificationsPopupMenuView({
            pollTimeoutValue: this.notificationPollRate,
            messageAndDevicesNotificationsEnabled: this.messageAndDevicesNotificationsEnabled,
            el: this.$('.notifications .header-nav-menu'),
            displayName: this.userProfile.get('displayName'),
            viewerSocialProfile: ViewerSocialProfile,
            userProfile: this.userProfile,
            userPreferences: this.userPreferences,
            openNotificationCallback: this.openNotificationList.bind(this),
            groupInviteSpammingDays: this.groupInviteSpammingDays,
            gcPlusFrameRole: this.gcPlusFrameRole, // Clean up ticket: CA-165763
            trainingPlans: this.trainingPlans
        });
        this.notificationsPopupMenuView.loadNotificationCounter();
        this.notificationsPopupMenuView.render();

        this.listenTo(
            this.notificationsPopupMenuView,
            NotificationsPopupMenuView.Events.REFRESH_COUNT,
            this.refreshNotificationCount,
            this
        );
        this.listenTo(
            this.notificationsPopupMenuView,
            NotificationsPopupMenuView.Events.ON_NAVIGATION,
            this.closeDropdowns,
            this
        );

        this.devicePopupMenuView = new DevicesPopupMenuView({
            pollTimeoutValue: this.deviceNotificationPollRate,
            messageAndDevicesNotificationsEnabled: this.messageAndDevicesNotificationsEnabled,
            el: this.$('.device-sync .header-nav-menu'),
            displayName: this.userProfile.get('displayName'),
            userPreferences: this.userPreferences
        });

        this.listenTo(this.devicePopupMenuView, DevicesPopupMenuView.Events.ON_NAVIGATION, this.closeDropdowns, this);

        this.devicePopupMenuView.load();

        this.userPopupMenuView = new UserPopupMenuView({
            el: this.$('.user-profile .header-nav-menu'),
            viewerSocialProfile: ViewerSocialProfile
        });

        this.listenTo(this.userPopupMenuView, UserPopupMenuView.Events.ON_NAVIGATION, this.closeDropdowns, this);
        this.userPopupMenuView.render();

        this.setupTooltips();

        this.openNotifications = false;

        this.widgetLimitErrorDialogView = new ReactComponentView();
        this.widgetLimitErrorDialogView.renderComponent(
            WidgetLimitErrorDialog,
            this.$('.widget-limit-error-dialog')[0],
            {}
        );

        this.listenTo(
            this.devicePopupMenuView,
            DevicesPopupMenuView.Events.SET_DEVICES_SYNC_DATA,
            this.setupDeviceSyncBanner,
            this
        );
    },

    getActorAvatarUrl: function() {
        if (!isReadonlyMode() || this.isProductSupportMode || !localStorage.getItem('actorProfileImage')) {
            return null;
        }

        const actorProfileImage = JSON.parse(localStorage.getItem('actorProfileImage'));

        return actorProfileImage.profileImageMedium;
    },

    // NOTIFICATIONS
    refreshNotificationCount: function(count) {
        var $newNotificationsAlert = this.$('.notifications .header-nav-link .new-items-alert');
        if (count > 0) {
            $newNotificationsAlert.show();
        } else {
            $newNotificationsAlert.hide();
        }
    },

    onNotificationTriggerClicked: function(e) {
        if (!$(e.currentTarget).hasClass('active')) {
            this.notificationsPopupMenuView.load();

            // track events for inbox toggle open
            AnalyticsUtil.push({
                event: 'track_event',
                category: 'Top Header Bar Events',
                action: 'Inbox Toggle Open'
            });
        } else {
            this.notificationsPopupMenuView.handleDropdownClosed();
        }
    },

    onDeviceSyncTriggerClicked: function(e) {
        if (!$(e.currentTarget).hasClass('active')) {
            this.devicePopupMenuView.closeLists();
            this.devicePopupMenuView.load();
        }
    },

    // USER PROFILE
    renderProfileImage: function() {
        var profileUrl = NavigationUtil.url('/profile/' + ViewerSocialProfile.get('displayName')),
            fullName = ViewerSocialProfile.get('fullName') || ViewerSocialProfile.get('displayName'),
            imageUrl = ViewerSocialProfile.getProfileImageUrlMedium();

        this.$('.user-profile .header-nav-link')
            .attr('href', profileUrl)
            .find('.avatar')
            .attr('src', imageUrl)
            .attr('alt', fullName);

        if (this.gcPlusFrameRole.featureEnabled() && !this.triggerAvatarRefresh) {
            // trigger avatar fetching AFTER tag is being rendered.
            this.triggerAvatarRefresh = Date.now();
            AvatarRefreshInstance.triggerRefresh(ViewerSocialProfile.get('profileId'));
        }
    },

    // CLICKS, LINKS AND TOOLTIPS BELOW
    setupTooltips: function() {
        _.each(
            tooltipMapper,
            function(tooltip) {
                new ToolTipView({
                    el: this.$(tooltip.selector + ' .header-nav-link'),
                    content: Localizer.localize(tooltip.label),
                    placement: tooltip.placement
                });
            },
            this
        );

        this.setupEvents();
    },

    hideTooltips: function() {
        $('.tooltip').hide();
    },

    handleNavigationLink: function(e) {
        if (!e.ctrlKey && !e.metaKey) {
            e.preventDefault();

            var navHandled = NavigationUtil.anchorTagHandler(e);

            if (!navHandled) {
                window.location.href = e.currentTarget.href;
            }
        }
    },

    handleDropdownClick: function(e) {
        this.$('.header-nav-link')
            .not(e.currentTarget)
            .removeClass('active');
        this.hideTooltips();
        $(e.currentTarget).toggleClass('active');
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
    },

    handleDropdownContentClick: function(e) {
        e.stopPropagation();
    },

    setupEvents: function() {
        $(document).on(
            'click',
            function(e) {
                // Won't close the menu if clicking on dialog
                let targetClassName = $(e.target).attr('class');
                if (typeof targetClassName !== 'undefined') {
                    let targetString = targetClassName.toString();
                    if (
                        targetString.length === 0 ||
                        targetString.includes('Dialog_dialog') ||
                        targetString.includes('ConnectionDialog_itemContainer') ||
                        targetString.includes('Button_btn')
                    ) {
                        return;
                    }
                }
                this.closeDropdowns();
            }.bind(this)
        );

        Backbone.history.on('route', this.closeDropdowns.bind(this));
    },

    closeDropdowns: function() {
        if (!this.openNotifications) {
            this.$('.header-nav-link').removeClass('active');
        }
        this.openNotifications = false;
        this.notificationsPopupMenuView.handleDropdownClosed();
    },

    openNotificationList: function() {
        this.openNotifications = true;
    },

    toggleSidebar: function() {
        this.trigger(MainSidebarView.Events.EXPAND_COLLAPSE);
        this.pushEventToAnalytics();
    },

    pushEventToAnalytics() {
        let menuClosed = $('body').hasClass('minimize-main-nav');

        AnalyticsUtil.push({
            event: 'track_event',
            category: 'Main Nav Menu',
            action: 'Toggle Open or Closed',
            label: menuClosed ? 'Closed' : 'Opened'
        });
    }
});

export default TopHeaderBarView;
